<template src="./template.html"></template>
<style lang="scss" src="./styles.scss" scoped></style>

<script setup>
import { ref } from "vue"
import { useShippingMethod } from "@/composables/useShippingMethod"
import NBRadioGroup from "@/app/Checkout/components/common/NBRadioGroup/index.vue"
import ShippingInfoModal from "@/app/Checkout/components/common/ShippingInfoModal/index.vue"

const showShippingInfoModal = ref(false)
const { shippingMethods, selectedShippingMethod, selectedShippingLabel } = useShippingMethod()

function openShippingInfo() {
  showShippingInfoModal.value = true
}
</script>
